import React from 'react';
import { CLegend } from 'src/components/charts/comps';
import { LegendParams } from 'src/components/charts/comps/CLegend/types';
import { useStateSelector } from 'src/redux';

interface LegendComposedProps {
  showProjectedA: boolean;
  showProjectedB: boolean;
  // Which assessment's legend row to render — placed on its own line under that assessment.
  version: 'a' | 'b';
}
export const LegendComposed: React.FC<LegendComposedProps> = ({ showProjectedA, showProjectedB, version }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  // A column is shown whenever EITHER version uses it, so both assessments' legends stay the same
  // length and line up. An item this version does not use is still rendered, but faded out
  // (disabled): 0.23 opacity, non-interactable — see Item. Version 2 (b) is the faded chart
  // overlay, so its (enabled) items render at 0.5 opacity.
  const showProjected = showProjectedA || showProjectedB;
  const hasProjected = version === 'a' ? showProjectedA : showProjectedB;
  const rowOpacity = version === 'a' ? 1 : 0.5;

  const legends = [
    {
      include: showProjected,
      enabled: hasProjected,
      params: { title: 'Unmodified Risk', id: `col_${version}_base`, color: colors.prussianBlue },
    },
    { include: true, enabled: true, params: { title: 'Live Risk', id: `col_${version}_live`, color: colors.gp1 } },
    {
      include: showProjected,
      enabled: hasProjected,
      params: { title: 'Projected Risk', id: `col_${version}_complete`, color: colors.brightBlue },
    },
    {
      include: true,
      enabled: true,
      params: { title: 'Risk Tolerance', id: `leg-car-${version}`, type: 'dash', color: colors.cflowerBlue },
    },
  ]
    .filter((el) => el.include)
    .map((el) => ({ ...el.params, opacity: rowOpacity, disabled: !el.enabled })) as LegendParams[];

  return <CLegend legends={legends} />;
};
